import { createMedia } from '@artsy/fresnel';

const AppMedia = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    desktop: 1024,
  },
});

export const MediaContextProvider = AppMedia.MediaContextProvider;
export const Media = AppMedia.Media;
export const createMediaStyle = AppMedia.createMediaStyle;
